import React from 'react';
import './App.css';
import AIRadio from './components/AIRadio';

function App() {
  return (
    <div className="App">
      <AIRadio />
    </div>
  );
}

export default App;